"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: " 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.88",
    width: "2.25",
    height: "9.04"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.25,2.55V4.92a8.74,8.74,0,1,1-6.5,0V2.55a11,11,0,1,0,6.5,0Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.88",
    width: "2.25",
    height: "9.04"
  }));
};

exports["default"] = _default;